import { Button } from '~/components/Button/Button';
import { Dialog } from '~/components/Dialog/Dialog';
import { useFormContext } from 'react-hook-form';
import { Schema } from '../schema';

interface Props {
  email: string | undefined;
  onClose: () => void;
}

export function InvalidCompetitionAdminDialog({ email, onClose }: Props) {
  const { setValue, getValues } = useFormContext<Schema>();

  function handleRemoveInvalidEmail() {
    setValue('admins', [...getValues('admins').filter(a => a !== email)]);
    onClose();
  }

  return (
    <Dialog isOpen={!!email} onClose={onClose}>
      <Dialog.Title>Användaren finns inte</Dialog.Title>

      <Dialog.Text>
        Du har lagt till en administratör med e-post adressen <strong>{email}</strong>. Denna användern finns inte
        registrerad och kan därför inte läggas till som administratör.
      </Dialog.Text>

      <Button.Group align="right">
        <Button type="button" variant="secondary" onClick={onClose}>
          Stäng
        </Button>

        <Button type="button" variant="primary" onClick={handleRemoveInvalidEmail}>
          Ok, ta bort
        </Button>
      </Button.Group>
    </Dialog>
  );
}
